export const USER_REJECTED = 'User Rejected';
